import React, { useState } from 'react';
import emailjs from 'emailjs-com';

const EmailForm = () => {
	const [form, setForm] = useState({
		name: '',
		email: '',
		subject: '',
		message: '',
	});
	const [toast, setToast] = useState({
		show: false,
		visible: false,
		msg: '',
		type: 'success',
	});

	const handleChange = (e) =>
		setForm({ ...form, [e.target.name]: e.target.value });

	const showToast = (msg, type) => {
		setToast({ show: true, visible: false, msg, type });
		requestAnimationFrame(() => setToast((t) => ({ ...t, visible: true })));
		setTimeout(() => {
			setToast((t) => ({ ...t, visible: false }));
			setTimeout(() => setToast((t) => ({ ...t, show: false })), 300);
		}, 3200);
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		emailjs.send(
			'service_rqpwugp',
			'template_contact',
			form,
			'DBkuHSQOvQowexN2O',
		);
		emailjs
			.send('service_rqpwugp', 'template_auto_reply', form, 'DBkuHSQOvQowexN2O')
			.then(
				() => showToast('Email sent successfully!', 'success'),
				() => showToast('Failed to send. Please try again.', 'error'),
			);
		setForm({ name: '', email: '', subject: '', message: '' });
	};

	const fields = [
		{ label: 'Name', name: 'name', type: 'text', placeholder: 'Your name' },
		{
			label: 'Email',
			name: 'email',
			type: 'email',
			placeholder: 'your@email.com',
		},
		{
			label: 'Subject',
			name: 'subject',
			type: 'text',
			placeholder: "What's this about?",
		},
	];

	return (
		<div className="email-form-wrap">
			{toast.show && (
				<div
					className={`toast ${toast.type}${toast.visible ? ' visible' : ''}`}
				>
					{toast.type === 'success' ? '✓' : '✕'} {toast.msg}
				</div>
			)}

			<form className="email-form" onSubmit={handleSubmit}>
				{fields.map(({ label, name, type, placeholder }) => (
					<div key={name} className="form-field">
						<label className="form-label">{label}</label>
						<input
							className="form-input"
							type={type}
							name={name}
							value={form[name]}
							onChange={handleChange}
							placeholder={placeholder}
							required
						/>
					</div>
				))}
				<div className="form-field">
					<label className="form-label">Message</label>
					<textarea
						className="form-input form-textarea"
						name="message"
						value={form.message}
						onChange={handleChange}
						placeholder="Your message..."
						required
					/>
				</div>
				<button type="submit" className="form-submit">
					Send Message →
				</button>
			</form>
		</div>
	);
};

export default EmailForm;
